export const TABLE_NAME = 'CHILD_WORK_ITEM_TABLE';
